import { createListenerMiddleware, addListener } from "@reduxjs/toolkit";
//import { addMediaListeners } from "../slices/media/mediaSlice";

const listenerMiddleware = createListenerMiddleware();
const startAppListening = listenerMiddleware.startListening;
const addAppListener = addListener();

export { listenerMiddleware, startAppListening, addAppListener };
